import { login as loginApi, getCurrentUser } from '@/api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('factory_token') || '',
    user: null,
    mustChangePassword: false
  }),
  getters: {
    isLoggedIn: (state) => !!state.token
  },
  actions: {
    async login(credentials) {
      const data = await loginApi(credentials)
      this.token = data.access_token
      localStorage.setItem('factory_token', data.access_token)
      this.mustChangePassword = data.must_change_password || false
    },
    async fetchCurrentUser() {
      const data = await getCurrentUser()
      this.user = data
      this.mustChangePassword = data.must_change_password || this.mustChangePassword
      return data
    },
    logout() {
      this.token = ''
      this.user = null
      this.mustChangePassword = false
      localStorage.removeItem('factory_token')
    }
  }
})
